var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4.4375,
    width: 13,
    height: 14,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6497 1.1875C18.7248 1.1875 23.6497 6.11237 23.6497 12.1875C23.6497 18.2626 18.7248 23.1875 12.6497 23.1875C6.57453 23.1875 1.64966 18.2626 1.64966 12.1875C1.64966 6.11237 6.57453 1.1875 12.6497 1.1875ZM16.3365 8.4128L10.9559 13.7934L8.96282 11.8004C8.66241 11.5 8.17536 11.5 7.87496 11.8004C7.57456 12.1008 7.57456 12.5878 7.87496 12.8883L10.9559 15.9692L17.4244 9.50066C17.7248 9.20026 17.7248 8.71321 17.4244 8.4128C17.124 8.1124 16.6369 8.1124 16.3365 8.4128Z",
    fill: "#009F84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickFill);
export default __webpack_public_path__ + "static/media/tick-fill.b830ad25a3b406a1eb9586bb1e2fbe23.svg";
export { ForwardRef as ReactComponent };